import React from 'react';
import { AppCard } from '@/components/atoms';

const ContactCompletePage: React.FC = () => {
  return (
    <div className="space-y-4">
      <AppCard title="お問い合わせ" isHeaderColor>
        <div className="mt-4 mb-4">
          <h4 className="text-lg font-bold mb-4">お問い合わせが完了しました</h4>
          <p>
            お問い合わせいただきありがとうございました。
            <br />
            お問い合わせを受け付けました。
            <br />
            <br />
            折り返し、担当者よりご連絡いたしますので、
            <br />
            恐れ入りますが、しばらくお待ちください。
          </p>
        </div>
      </AppCard>
    </div>
  );
};

export default ContactCompletePage;
